'use strict';

angular.module('cf.app').directive('cfJsonEditorCodeEditor', [
  () => ({
    restrict: 'E',
    scope: { editor: '=' },
    template: JST.cf_json_editor_code_editor(),

    link: function($scope, $el) {
      $scope.editor.attach($el.find('[data-editor]'));
      $scope.$on('$destroy', $scope.editor.destroy);
    }
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/json/cf_json_editor_code_editor_directive.js